export { default } from './SwipeableDrawer';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/SwipeableDrawer/index.js
// module id = 851
// module chunks = 2